<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeCloseBranchDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100">
        <!-- title -->
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL">
            <span>{{ "close-branch.title-1" | translate }}</span>
            <span class="zx-100-opp">-</span>
            <span>{{ "choose-branch.naming." + getPrintingService() + "." + branch | translate }}</span>
            <span class="zx-100-opp">-</span>
            <span>{{ "close-branch.title-2" | translate }}</span>
        </h4>

        <div class="d-flex flex-column gap-3 align-items-center w-100 pt-3">
            <span class="text-center pb-4" [class.zx-ltr]="!isRTL">
                {{ close_msg }}
            </span>
            <button color="primary" mat-raised-button class="rounded-pill w-100 text-white"
                (click)="closeCloseBranchDialog()">
                {{ "close-branch.btn" | translate }}
            </button>
        </div>

    </div>
</div>